<template>
  <section v-if="activeDwelling" class="row">
    <card>
      <div class="d-flex flex-wrap">
        <div class="col-12 mb-4">
          <div class="row">
            <div class="col-12">
              <h3>Editing {{ activeDwelling.label }}</h3>
              <button class="btn btn-sm btn-primary" @click="viewAll">View All Dwellings</button>
              <button class="btn btn-sm btn-primary ml-1" @click="saveDwelling(activeDwelling)">Save</button>
            </div>
          </div>
        </div>
        <div class="col-6 mb-4">
          <div class="row">
            <div class="col-6 mb-4">
              Label
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.label"
              />
            </div>
            <div class="col-6 mb-4">
              Display Name
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.displayName"
              />
            </div>
            <div class="col-6 mb-4">
              Dwelling Type
              <select class="form-control" v-model="activeDwelling.type">
                <option value="house">House</option>
                <option value="townhouse">Townhouse</option>
                <option value="apartment">Apartment</option>
              </select>
            </div>
            <div class="col-6 mb-4">
              Bedrooms
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.beds"
              />
            </div>
            <div class="col-6 mb-4">
              Bathrooms
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.baths"
              />
            </div>
            <div class="col-6 mb-4">
              Living Rooms
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.livingRooms"
              />
            </div>
            <div class="col-6 mb-4">
              Car Spaces
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.cars"
              />
            </div>
            <div class="col-6 mb-4">
              Dwelling Size (m<sup>2</sup>)
              <input 
                type="text" 
                class="form-control" 
                v-model="activeDwelling.size"
              />
            </div>               
            <div class="col-6 mb-4">
              House Width (m)
              <input 
                type="text" 
                class="form-control" 
                v-model="activeDwelling.houseWidth"
              />
            </div>               
            <div class="col-6 mb-4">
              Minimum Frontage Width (m)
              <input 
                type="text" 
                class="form-control" 
                v-model="activeDwelling.minimumFrontageWidth"
              />
            </div>               
            <div class="col-6 mb-4">
              Price
              <input 
                type="text" 
                class="form-control" 
                :value="activeDwelling.price"
                @input="event => activeDwelling.price = event.target.value.replace(/[^0-9.]/g, '')"
              />
            </div>               
            <div class="col-6 mb-4">
              Virtual Tour URL
              <input 
                type="text" 
                class="form-control" 
                v-model="activeDwelling.virtualTourUrl"
              />
            </div>               
            <div class="col-12 mb-4">
              Description
              <ck-editor
                v-model="activeDwelling.description"
                id="dwellingDescription"
              />
            </div>
            <div class="col-12 mb-4">
              Feature List
              <ck-editor
                v-model="activeDwelling.featureList"
                id="dwellingFeatureList"
              />
            </div>
            <div class="col-12 mb-4">
              Is visible on webfeed?
              <info-box>
                If selected the dwelling will be visible in the dwelling listing page and on the webfeed.
              </info-box>
              <br>
              <toggle-button 
                v-model="activeDwelling.isVisibleOnWebfeed" 
                :color="{ checked: '#28a745', unchecked: '#b8b8b8' }"
                :sync="true"
                :width="30" 
                :height="20"
              />
            </div>
          </div>
        </div>

        <div class="col-6 mb-4">
          <div class="row">            
            <div v-if="activeDwelling.outlookImages" class="col-12 mb-4">
              Outlook Images
              <input-asset
                v-model="activeDwelling.outlookImages"
                key="outlook-images"
                :multiple="true"
              />
            </div>
            <div v-if="activeDwelling.facadeImages" class="col-12 mb-4">
              Facade Images
              <input-asset
                v-model="activeDwelling.facadeImages"
                key="facade-images"
                :multiple="true"
              />
            </div>
            <div v-if="activeDwelling.miscImages" class="col-12 mb-4">
              Misc Images
              <input-asset
                v-model="activeDwelling.miscImages"
                key="misc-images"
                :multiple="true"
              />
            </div>
            <div class="col-12 mb-4">
              Gallery Images
              <input-asset
                v-model="activeDwelling.galleryImages"
                key="gallery-images"
                :multiple="true"
              />
            </div>
            <div class="col-12 mb-4">
              Overlay Image
              <input-asset
                v-model="activeDwelling.overlayImage"
                key="overlay-image"
                :multiple="false"
              />
            </div>
            <div v-if="activeDwelling.floorplanImages" class="col-12 mb-4">
              Floorplan Images
              <input-asset
                v-model="activeDwelling.floorplanImages"
                key="floorplan-images"
                :multiple="true"
              />
            </div>
            <div class="col-12 mb-4">
              PDFs
              <input-asset
                v-model="activeDwelling.pdfs"
                key="pdfs"
                :multiple="true"
                defaultCategory="misc"
              />
            </div>
            <div class="col-12 mb-4">
              Builder Label
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.builderLabel"
              />
            </div>
            <div class="col-12 mb-4">
              Builder Logo
              <input-asset
                v-model="activeDwelling.builderImage"
                key="builder-image"
              />
            </div>
            <div class="col-12 mb-4">
              Builder URL
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.builderUrl"
              />
            </div>
            <div class="col-12 mb-4">
              House Design
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.houseDesign"
              />
            </div>
            <div class="col-12 mb-4">
              Colour Scheme
              <input
                type="text"
                class="form-control"
                v-model="activeDwelling.colourScheme"
              />
            </div>
          </div>
        </div>
      </div>
    </card>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import CkEditor from '@/components/CKEditor'
import InfoBox from '@/components/InfoBox'
import InputAsset from '@/components/InputAsset'
import InputMultiSelect from '@/components/InputMultiSelect'

export default {
  components: { CkEditor, InfoBox, InputAsset, InputMultiSelect },

  data () {
    return {
      activeDwellingId: null,
    }
  },

  computed: {
    ...mapGetters([
      'dwellings'
    ]),

    activeDwelling () {
      return this.dwellings.find(dwelling => dwelling._id === this.activeDwellingId)
    },
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
    this.$store.dispatch('FETCH_DWELLINGS')
  },

  mounted () {
    this.activeDwellingId = this.$route.params.id
  },

  methods: {
    viewAll () {
      this.$router.push('/live/dwellings')
    },

    saveDwelling (dwelling) {
      this.$store.dispatch('SAVE_DWELLING', dwelling)
      this.viewAll()
    },
  },
}
</script>
